import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Removed TDCreate and TICreate
import PICreate from './PumpSpareInternational/Create';
import AraiMCreate from './AraiManufacturing/Create';

function PoEnquiryCreate() {
  const [purchaseenquirytype, setpurchaseenquirytype] = useState('');
  const [purchaseenquirycategory, setpurchaseenquirycategory] = useState('');
  const [purchaseenquirytypeDisabled, setpurchaseenquirytypeDisabled] = useState(false);
  const [purchaseenquirycategoryDisabled, setpurchaseenquirycategoryDisabled] = useState(false);

  const handlepurchaseenquirytypeChange = (event) => {
    const selectedpurchaseenquirytype = event.target.value;
    setpurchaseenquirytype(selectedpurchaseenquirytype);
    setpurchaseenquirycategory('');
    setpurchaseenquirycategoryDisabled(false);
    setpurchaseenquirytypeDisabled(true);

    if (selectedpurchaseenquirytype === 'Manufacturing') {
      setpurchaseenquirycategory('Domestic');
      setpurchaseenquirycategoryDisabled(true);
    }
    if (selectedpurchaseenquirytype === 'Pump Spare') {
      setpurchaseenquirycategory('International');
      setpurchaseenquirycategoryDisabled(true);
    }
  };

  const handlepurchaseenquirycategoryChange = (event) => {
    setpurchaseenquirycategory(event.target.value);
    setpurchaseenquirycategoryDisabled(true);
  };

  // Cleaned-up PageDisplay
  const componentMap = {
    'Pump Spare-International': <PICreate />,
    'Manufacturing-Domestic': <AraiMCreate />,
  };

  const PageDisplay = () => {
    const key = `${purchaseenquirytype}-${purchaseenquirycategory}`;
    return componentMap[key] || null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD PURCHASE ENQUIRY</h6>
          <Link to="/poenquiryindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select
                  onChange={handlepurchaseenquirytypeChange}
                  value={purchaseenquirytype}
                  disabled={purchaseenquirytypeDisabled}
                >
                  <option value="">--Please choose an option--</option>
                  {/* Removed Tubing option */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Removed Tubing PO category dropdown */}
            {purchaseenquirytype === 'Pump Spare' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="International" disabled />
                </Form.Group>
              </Col>
            )}
            {purchaseenquirytype === 'Manufacturing' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="Domestic" disabled />
                </Form.Group>
              </Col>
            )}

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PoEnquiryCreate;
